import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { ScrollTopBtnDirective } from '@otas/utils/directives/styles/scroll-top-btn.directive';
declare let $: any;
@Component({
    // tslint:disable-next-line:component-selector
    selector: '[fw-body],fw-body',
    templateUrl: './frame-work-body.component.html',
    styleUrls: ['./frame-work-body.component.scss'],
    providers: [ScrollTopBtnDirective],
    standalone: false
})
export class FrameWorkBodyComponent implements OnInit {

  constructor(private el: ElementRef, private scroll: ScrollTopBtnDirective) { }

  ngOnInit() {

  }
  activate() {
    setTimeout(() => {
      // this.scroll.onClick();
      window.scrollTo(0, 0);
    }, 200);
  }
}
